import React from 'react';
import { Box, Typography, Paper, useTheme } from '@mui/material';

interface SignaturePreviewProps {
  content: string;
  title?: string;
  showTitle?: boolean;
}

export const SignaturePreview: React.FC<SignaturePreviewProps> = ({
  content,
  title = 'Preview',
  showTitle = true,
}) => {
  const theme = useTheme();

  return (
    <Box>
      {showTitle && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {title}
        </Typography>
      )}
      
      <Paper
        elevation={0}
        sx={{
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          p: 2,
          backgroundColor: theme.palette.background.paper,
          minHeight: 120,
        }}
      >
        {content ? (
          <Box
            dangerouslySetInnerHTML={{ __html: content }}
            sx={{
              fontSize: '14px',
              fontFamily: theme.typography.body1.fontFamily,
              color: theme.palette.text.primary,
              '& a': {
                color: theme.palette.primary.main,
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              },
            }}
          />
        ) : (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: 'italic' }}
          >
            No signature content to preview
          </Typography>
        )}
      </Paper>
    </Box>
  );
};